import React, { useState, useEffect } from 'react';
import ReactAudioPlayer from 'react-audio-player';
import { useTranslation } from "react-i18next";
import Swal from 'sweetalert2';
import { useParams } from "react-router-dom";
import axios from "axios";
import { useAuth } from '../../../../../context/AuthContext';
import ReactPlayer from 'react-player';
import './matchcss.css';

// CSS for styling
const inputStyle = {
    padding: "10px",
    fontSize: "16px",
    borderRadius: "8px",
    border: "1px solid #ccc",
};



const Write = (props) => {
    const { t } = useTranslation();
    const [obj, setObj] = useState([]);
    const [answers, setAnswers] = useState([]);
    const [answerCount, setAnswerCount] = useState([]);
    const [url, setUrl] = useState([]);
    const [msg, setMsg] = useState([]);
    const { user } = useAuth();
    const params = useParams();
    const [hasMediaContent, sethasMediaContent] = useState([]);
    const [imageDimensions, setImageDimensions] = useState({ width: 0, height: 0 });
    const [realcontent, setrealcontent] = useState([]);
    const [subjectName, setSubjectName] = useState("");
    const ATTEMPT_KEY = `choice_attempt_${props.questionNumber}`;
    const [soundurl, setSoundurl] = useState([]);

    const getSubject = async () => {
        try {
            const headerss = {
                "accept": "*/*",
                'Content-Type': 'application/json',
                'Access-Control-Allow-Credentials': 'false',
                'Authorization': 'Bearer ' + user.token
            };
            let url = "https://api.heryerdeingilizce.com/api/user/Content/GetSubject";
            await axios({
                method: 'GET',
                url: url,
                headers: headerss,
                params: {
                    courseId: params['courseid'],
                }
            }).then(res => {
                if (res.data['success']) {
                    setSubjectName(res.data['data']['subjects'][params['subjectid'] - 1]['subjectName'] + " - " + res.data['data']['subjects'][params['subjectid'] - 1]['subjectDesc'])
                }
            });
        } catch (err) {
            console.log();
        }
    };
    const Request = async (userAnswer) => {
        try {
            const headerss = {
                "accept": "*/*",
                'Content-Type': 'application/json',
                'Access-Control-Allow-Credentials': 'false',
                'Authorization': 'Bearer ' + user.token
            };
            let url = "https://api.heryerdeingilizce.com/api/user/Content/Answer";
            await axios({
                method: 'POST',
                url: url,
                params: {
                    courseId: Number(params.courseid),
                    question: Number(props.data.id),
                    answer: userAnswer.toString()
                },
                headers: headerss
            }).then(res => {
                localStorage.removeItem(ATTEMPT_KEY);

                if (res.data['success']) {
                    props.playSuccessSound?.();
                    Swal.fire({
                        title: "Başarılı!",
                        icon: "success",
                        confirmButtonText: `Tamam`,
                        timer: 3000,
                    }).then(() => {
                        let newurl = Number(params['id']) + 1;
                        window.location.href = "/user/course/question/" + params['courseid'] + "/" + params['subjectid'] + "/" + newurl;
                    });
                }
                else {
                    if (res.data['alertType'] === "question") {
                        props.playErrorSound?.();
                        Swal.fire({
                            title: "Hatalı cevap",
                            //text: "Doğru Cevap: " + res.data['message'],
                            text: props.data.notfyText,
                            icon: "error",
                            confirmButtonText: `Tamam`,
                        }).then(() => {
                            let newurl = Number(params['id']) + 1;
                            window.location.href = "/user/course/question/" + params['courseid'] + "/" + params['subjectid'] + "/" + newurl;
                        });
                    }
                    else {
                        let errorMsg = res['data']['message'];
                        props.playErrorSound?.();
                        Swal.fire({
                            title: "Hata",
                            text: errorMsg,
                            icon: "error",
                            confirmButtonText: `Tamam`,
                        }).then(() => {
                            let newurl = Number(params['id']) + 1;
                            window.location.href = "/user/course/question/" + params['courseid'] + "/" + params['subjectid'] + "/" + newurl;
                        });
                    }
                }
            });
        } catch (err) {
            setMsg(err.message);
        }
    };
    const getDynamicPadding = () => {
        const ratio = imageDimensions.width / imageDimensions.height;
        if (ratio > 1) {
            // Yatay (16:9 gibi)
            return { paddingTop: "10px", paddingBottom: "10px" };
        } else if (ratio < 1) {
            // Dikey (9:16 gibi)
            return { paddingLeft: "10px", paddingRight: "10px" };
        }
        return {}; // Kare resimler için padding yok
    };
    const answerWriteHandle = async (e) => {
        e.preventDefault();
        const formData = new FormData(e.target);

        const values = [];

        for (let [key, value] of formData.entries()) {
            if (key.startsWith("answer_")) {
                values.push(value.trim());
            }
        }

        const result = values.join(",");
        const correctAnswer = props.data.answer;
        const attempt = parseInt(localStorage.getItem(ATTEMPT_KEY) || "0", 10);

        //1. DENEME
        if (attempt === 0 || attempt === 1) {
            if (result === correctAnswer) {
                Request(result);
            } else {
                localStorage.setItem(ATTEMPT_KEY, String(attempt + 1));

                props.playErrorSound?.();

                Swal.fire({
                    title: attempt === 0 ? "Tekrar Deneyiniz!" : "Son bir kez deneyiniz!",
                    text: props.data.notfyText,
                    icon: "warning",
                }).then(() => window.location.reload());
            }
            return;
        }

        // 2. DENEME → DİREKT BACKEND
        Request(result);




    };
    useEffect(() => {
        if (localStorage.getItem(ATTEMPT_KEY) === null) {
            localStorage.setItem(ATTEMPT_KEY, "0");
        }
    }, [ATTEMPT_KEY]);
    useEffect(() => {
        getSubject();

        setObj(JSON.parse(props.data.contentStr));
        if (obj['type'] === "sound" || obj['type'] === "video" || obj['type'] === "image" || obj['type'] === "image_sound") {
            sethasMediaContent(true)
        }
        else {
            sethasMediaContent(false)

        }
        let str = props.data.detail;
        let parts = str.split('_');
        let result = parts[0];
        for (let i = 1; i < parts.length; i++) {
            result += `${parts[i - 1]}____<span style="color:red;">${i}</span>___` + parts[i];
        }
        document.getElementById('output').innerHTML = result;

        setrealcontent(result)
        let answerss = props.data.answer.split(',');
        setAnswers(answerss);
        setAnswerCount(answerss.length);
        if (obj['type'] === "image_sound") {
            setUrl(JSON.parse(props.data.contentStr)['url']);
            setSoundurl(JSON.parse(props.data.contentStr)['soundUrl'])
        }
        else {
            setUrl(JSON.parse(props.data.contentStr)['url']);
        }
    }, []);

    return (
        <div>
            <span style={{ color: "black" }}> <b><i>{subjectName}</i></b></span>

            <br />
            <b>Write Sorusu</b>
            <br />
            {msg}
            <div style={{ alignItems: "center", textAlign: "center" }}>
                {obj['type'] === "image_sound" ? (
                    <div>
                        <div style={{
                            justifyContent: "center",
                            alignItems: "center",
                            display: "flex",  // sadece medya varsa flex, yoksa block
                            width: "100%",
                            maxWidth: "500px",
                            margin: "0 auto",
                            overflow: "hidden",
                            padding: "10px"
                        }}>
                            <div style={{
                                width: "100%",
                                height: "auto",
                                maxWidth: "500px"
                            }}>
                                <ReactAudioPlayer
                                    src={url}
                                    autoPlay={false}
                                    controls={true}
                                    controlsList="nodownload "

                                />
                            </div>

                        </div>
                        <br />
                        <div style={{
                            justifyContent: "center",
                            alignItems: "center",
                            display: "flex",  // sadece medya varsa flex, yoksa block
                            width: "auto",
                            maxWidth: "auto",
                            margin: "0 auto",
                            overflow: "hidden",
                            padding: "10px"
                        }}>
                            <div style={{
                                width: "auto",
                                height: "auto",
                                margin: "0 auto",
                                overflow: "hidden",
                                ...getDynamicPadding()  // Dinamik padding uygula
                            }}>
                                <img
                                    src={soundurl}
                                    alt="Question Media"
                                    style={{
                                        width: "80%",
                                        height: "100%",
                                        maxHeight: "250px",
                                        objectFit: "contain", // Resmi kutuya sığdırırken oranlarını korur
                                        borderRadius: "10px", // Opsiyonel, görseli daha hoş göstermek için
                                    }}
                                />

                            </div>

                        </div>
                    </div>

                ) : (
                    <div></div>
                )}
                {obj['type'] === "sound" && (
                    <div style={{
                        justifyContent: "center",
                        alignItems: "center",
                        display: "flex",  // sadece medya varsa flex, yoksa block
                        width: "100%",
                        maxWidth: "500px",
                        margin: "0 auto",
                        overflow: "hidden",
                        padding: "10px"
                    }}>
                        <div style={{
                            width: "100%",
                            height: "auto",
                            maxWidth: "500px"
                        }}>
                            <ReactAudioPlayer
                                src={url}
                                controls
                            />
                        </div>
                    </div>

                )}
                {obj['type'] === "video" && (
                    <div style={{
                        justifyContent: "center",
                        alignItems: "center",
                        display: "flex",  // sadece medya varsa flex, yoksa block
                        width: "100%",
                        maxWidth: "500px",
                        margin: "0 auto",
                        overflow: "hidden",
                        padding: "10px"
                    }}>
                        <div style={{
                            width: "100%",
                            height: "auto",
                            maxWidth: "500px",
                            minHeight: "300px"
                        }}>
                            <ReactPlayer
                                className='react-player'
                                width={"100%"}
                                height={"300px"}
                                url={url}
                                controls={true}
                            />
                        </div>

                    </div>

                )}
                {obj['type'] === "image" && (
                    <div style={{
                        justifyContent: "center",
                        alignItems: "center",
                        display: "flex",  // sadece medya varsa flex, yoksa block
                        width: "100%",
                        maxWidth: "500px",
                        margin: "0 auto",
                        overflow: "hidden",
                        padding: "10px"
                    }}>
                        <div style={{
                            width: "100%",
                            maxWidth: "500px",
                            height: "auto",
                            margin: "0 auto",
                            overflow: "hidden",
                            ...getDynamicPadding()  // Dinamik padding uygula
                        }}>
                            <img
                                src={url}
                                alt="Question Media"
                                style={{
                                    width: "100%",
                                    height: "100%",
                                    objectFit: "contain", // Resmi kutuya sığdırırken oranlarını korur
                                    borderRadius: "10px", // Opsiyonel, görseli daha hoş göstermek için
                                }}
                            />
                        </div>

                    </div>

                )}
                {!(obj['type'] === "sound" || obj['type'] === "video" || obj['type'] === "image" || obj['type'] === "image_sound") && (
                    <>
                        <br />
                        <br />
                    </>
                )}
                <b style={{ fontSize: "18px", fontFamily: 'calibri', color: "black" }}>
                    {obj['text']}

                </b>
            </div>
            <br />
            <div style={{ alignItems: "center", textAlign: "center" }}>
                <span id='output'>
                </span>
            </div>
            <br />
            <div className="d-flex justify-content-center" style={{ fontSize: 20 }}>
                <form onSubmit={answerWriteHandle}>
                    {answers &&
                        answers.map((dt, index) => (
                            <div
                                className="mb-3"
                                key={index}
                                style={{ display: "flex", alignItems: "center" }}
                            >
                                <span
                                    style={{
                                        marginRight: "10px",
                                        fontWeight: "bold",
                                        color: "red",
                                    }}
                                >
                                    {index + 1}
                                </span>

                                <input
                                    className="form-control"
                                    name={`answer_${index}`}   // ⭐ ÖNEMLİ
                                    required
                                    style={inputStyle}
                                />
                            </div>
                        ))}

                    <br />

                    {props.answered ? (
                        <b style={{ fontSize: "15px" }}>
                            Cevaplanmış: <i>{props.realanswer}</i>
                        </b>
                    ) : (
                        <div className="d-flex justify-content-center">
                            <button type="submit" className="save-btn">
                                {t("saveAndContinue")}
                            </button>
                        </div>
                    )}
                </form>

            </div>
            <br />
            <hr />
        </div >
    );
};

export default Write;
